// Vue
import Vue from 'vue';

// Services
import { arrayLoop } from 'services/array';
import { createScroll, destroyScroll } from 'services/scroll';


// @function activateChild
// Makes a child active
//
// @param {Element} child - a JavaScript element to assign the active state to

const activateChild = (child) => child.classList.add(`reveal__child--active`);


// @function getChildren
// Gets children of the specified selector
//
// @param {Element} el – a JavaScript element to get the children from
// @param {Object} value – the value Object from the directive

const getChildren = (el, { child }) => (child ? el.querySelectorAll(child) : el.children) || [];


// @function setupChildren
// Gets children, loops through them and adds the requisite child class
//
// @param {Element} el – a JavaScript element to get the children from
// @param {Object} value – the value Object from the directive

const setupChildren = (el, value) => {
  const children = getChildren(el, value);
  const elActive = el.dataset.scrollReveal === `true`;

  arrayLoop(children, (i, child) => {
    child.classList.add(`reveal__child`);

    if (value.stagger) {
      child.classList.add(`reveal__child--stagger`);
      child.style.setProperty(`--reveal-delay`, i);
    }

    if (elActive) {
      activateChild(child);
    }
  });
};


// @directive scroll-reveal
// Add scroll reveal
//
// @param {Object} value – The propertise object for the reveal
// @param {String} value.id – unique id for this scroll section
// @param {Number} [value.stagger=125] – time between each element being revealed (ms)
// @param {Selector} [value.child] – specific child to apply active class to, defaults to the direct children
// @param {Function} [value.enter] – callback triggered on element enter
// @param {Object} [value.enterProps] – properties object for enter
// @param {Number} [value.enterProps.trigger=66.67] – trigger percentage of viewport for enter to be set

Vue.directive(`scroll-reveal`, {
  inserted(el, { value }) {
    if (!value) value = {};

    const id = value.id;

    if (!id) {
      console.warn(`No id specified for v-scroll-reveal`);
      return false;
    }

    el.classList.add(`reveal`);
    el.dataset.scrollReveal = false;

    setupChildren(el, value);

    if (value.stagger && value.stagger !== true) {
      el.classList.add(`reveal--stagger`);
      el.style.setProperty(`--reveal-stagger`, value.stagger);
    }

    createScroll(`reveal-${id}`, {
      el,
      enter: () => {
        if (typeof(value.enter) === `function`) (value.enter)();

        el.classList.add(`reveal--active`);
        el.dataset.scrollReveal = true;

        arrayLoop(getChildren(el, value), (i, child) => activateChild(child));
      },
      enterProps: value.enterProps || {},
    });
  },
  componentUpdated(el, { value }) {
    setupChildren(el, value);
  },
  unbind(el, { value }) {
    const id = (value || {}).id;

    if (id) destroyScroll(`reveal-${id}`);
  },
});



// WEBPACK FOOTER //
// ./client/plugins/scroll.js